import type {NamedSetState} from 'app/gemStore/devtools';
import {generateRandomString} from 'app/utils/hash/generateRandomString';

import {type NotificationMessage, type NotificationMessageAction, NotificationPosition, NotificationType} from '../interfaces';

import type {NotificationsSystemSlice} from './types';

function getDefaultNotification(): NotificationMessage {
    return {
        id: generateRandomString(),
        title: '',
        message: '',
        status: NotificationType.ERROR,
        position: NotificationPosition.topRight,
        dismissible: true,
        dismissAfter: 10000,
        allowHTML: false,
        closeButton: true,
    };
}

export const createNotificationsSystemSlice = (set: NamedSetState<NotificationsSystemSlice>, get: () => NotificationsSystemSlice) => ({
    notifications: [],

    addNotification(notificationMessageAction: NotificationMessageAction): void {
        set({notifications: [...get().notifications, {...getDefaultNotification(), ...notificationMessageAction}]}, false, 'notifications/addNotification');
    },

    removeNotification(id: string): void {
        set({notifications: get().notifications.filter((notification) => notification.id !== id)}, false, 'notifications/removeNotification');
    },

    removeAllNotifications(): void {
        set({notifications: []}, false, 'notifications/removeAllNotifications');
    },
});
